export const URL_ORIGIN = "https://www.tabla.com.sg/";
export const OG_SITE_NAME = "Tabla";
export const ROBOTS =
  "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1";
export const OG_IMAGE = "/web2-assets/tabla_default.webp";

export const FB_APP_ID = "276165649676865";

export const LOCALHOST = "http://localhost";
